import styled, { css } from 'styled-components';
import theme from 'theme/theme';
import NavLink from '../../components/NavLink';

const MenuLink = styled(NavLink)`
  display: block;
  width: 100%;
  padding: 15px 15px 15px 25px;
  min-height: 55px;
  color: ${theme.colors.dark};
  text-decoration: none;
  &:hover,
  &.active,
  &.is-active {
    cursor: pointer;
    background: ${theme.colors.mediumLight};
    color: ${theme.colors.dark};
  }
  &.is-active,
  &.active {
    cursor: pointer;
    color: ${theme.colors.primary};
    background: ${theme.colors.mediumLight};
  }
  @media (min-width: ${theme.breakpoints.desktop}) {
    ${props =>
      props.depth > 0 &&
      css`
        padding-left: 30px;
      `}
  }
  svg {
    margin-right: 7px;
  }
  ${props =>
    props.depth === 0 &&
    css`
      @media (min-width: ${theme.breakpoints.desktop}) {
        padding-left: 15px;
        color: ${theme.colors.dark};
        font-size: ${theme.fontSizes.small};
        &:hover,
        &.active,
        &.is-active {
          background: ${theme.colors.primary};
          color: ${theme.colors.white};
        }
      }
    `}
`;

export default MenuLink;
